import { cn } from '@/lib/utils'
import { LossRunClaimStatus } from '@/models/lossRunRequest'

const STATUS_LABELS: Record<LossRunClaimStatus, string> = {
  [LossRunClaimStatus.OPEN]: 'Open',
  [LossRunClaimStatus.CLOSED]: 'Closed',
  [LossRunClaimStatus.UNKNOWN]: 'Unknown',
}

const STATUS_STYLES: Record<LossRunClaimStatus, string> = {
  [LossRunClaimStatus.OPEN]: 'bg-orange-50 text-orange-600',
  [LossRunClaimStatus.CLOSED]: 'bg-green-50 text-green-700',
  [LossRunClaimStatus.UNKNOWN]: 'bg-neutral-100 text-neutral-600',
}

export function ClaimStatusBadge({ status }: { status?: LossRunClaimStatus }) {
  if (!status) return <span className="text-muted-foreground">—</span>

  return (
    <span
      className={cn('inline-block rounded-full px-2.5 py-0.5 text-xs font-medium', STATUS_STYLES[status])}
    >
      {STATUS_LABELS[status]}
    </span>
  )
}
